export const splitString = (str: string, size: number) => {
  if (size <= 0) {
    return [str];
  }
  const resultado = [];
  for (let i = 0; i < str.length; i += size) {
    resultado.push(str.substring(i, i + size));
  }
  return resultado;
};
